import type { RootState } from '@app/types';

import type { Project } from '../../types/project';
import type { ActivityProject, FilenameError, ProjectsMainSearchData, Tag, TagsList } from './types';

export const getProjects = (state: RootState): Project[] => state.projects.projectsList.list;

export const getActivityProjectsMapping = (state: RootState): ActivityProject[] => {
    if (state.projects?.projectsList?.list?.length) {
        return state.projects.projectsList.list.map((project) => ({
            id: project.id,
            branch: project.branches?.currentId ?? null,
        }));
    }

    return state.projects.activityProjectsMapping;
};

export const getProjectsAllTags = (state: RootState): TagsList => state.projects.tags.all;

export const getProjectsActiveTags = (state: RootState): TagsList => state.projects.tags.active;

export const getProjectsTags = (state: RootState, projectId: string): Tag[] | null =>
    state.projects.tags.projectsTags?.[projectId] ?? null;

export const isProjectsTagsUpdating = (state: RootState): boolean => state.projects.tags.isUpdating;

export const isProjectsListUpdating = (state: RootState): boolean => state.projects.isUpdating;

export const getProjectsIsCollapsedMap = (state: RootState): { [id: string]: boolean } =>
    Object.fromEntries(
        state.projects.projectsList.list.map(
            (project) => [/* key: */ project.id, /* value: */ project.isCollapsed] as const,
        ),
    );

export const getProjectsIdsFromList = (state: RootState): string[] =>
    state.projects.activityProjectsMapping.map((project) => project.id);

export const getProjectsMainSearchIsLoading = (state: RootState): boolean => state.projects.searchSuggestions.isLoading;

export const getProjectsMainSearchCacheData = (
    state: RootState,
    query: string,
    dataObject: string,
): ProjectsMainSearchData => state.projects.searchSuggestions.results?.[dataObject]?.[query];

export const getFilenameError = (state: RootState): FilenameError => state.projects.filenameError;

export const getProjectsActiveCount = (
    state: RootState,
    projectId: string,
    branchId: string | undefined | null,
): number | undefined => {
    if (branchId) {
        return state.projects.activeCount?.[`${projectId}:${branchId}`]?.count;
    }

    return state.projects.activeCount?.[projectId]?.count;
};

export const getProjectsPage = (state: RootState): number => state.projects.projectsList?.page || 1;

export const hasMoreProjectsToLoad = (state: RootState): boolean => state.projects.projectsList.hasMore;

export const getTasksBadge = (state: RootState): number => state.projects.tasksBadge;
